export default __webpack_public_path__ + "static/media/spain.e3db1b5f.svg";